import React, { useEffect, useState } from "react";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import * as jnb from "react-bootstrap";
import { commonColumn, serialNumberColumn } from "../CommonUtils/CommunColumns";

export default function UniversityWiseSubAndFacultyRepo() {
  // ******** hooks********
  const [universitydata, setUniversitydata] = useState([]);
  const [universityTable, setUniversityTable] = useState(false);
  const [universityName, setUniversityName] = useState("");
  const [facultydata, setFacultydata] = useState([]);
  const [facultyTable, setFacultyTable] = useState(false);
  const [subjectTable, setSubjectTable] = useState(false);

  // ********University wise Data*******
  function GetUniversityData() {
    let url = `${config.url.FAC_URL}getUnvWiseReport`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01" && res?.data?.status === true) {
        setUniversitydata(res?.data?.UnvWiseReport);
        setUniversityTable(true);
        setFacultyTable(false);
        setSubjectTable(false);
      } else {
        setUniversitydata([]);
        setUniversityTable(true);
        setFacultyTable(false);
        setSubjectTable(false);
      }
    });
  }
  useEffect(() => {
    GetUniversityData();
  }, []);

  function GetFacultyData(ubcode, type) {
    const url = `${config.url.FAC_URL}getFacultyDetailsReport?ubCode=${ubcode}`;

    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01" && res?.data?.status === true) {
        let faculty = res.data.fac_details || [];

        if (type === "maker") {
          faculty = faculty.filter((f) => f.is_checker_approved == null);
        } else if (type === "checker") {
          faculty = faculty.filter((f) => f.is_checker_approved != null);
        }
        console.log("Filtered Faculty Data:", faculty); // Debug log

        setFacultydata(faculty);
        setFacultyTable(true);
        setUniversityTable(false);
        setSubjectTable(false);
      } else {
        setFacultydata([]);
        setFacultyTable(true);
        setUniversityTable(false);
        setSubjectTable(false);
      }
    });
  }

  // ******** Faculty wise Columns ********
  const facultyWiseColumns = [
    serialNumberColumn,
    commonColumn("Faculty Name", "fac_name", false, "left"),
    commonColumn("Gender", "gender", false, "left"),
    commonColumn("DOB", "dob", false, "left"),
    commonColumn("Date of Joining", "doj", false, "left"),
    commonColumn("Contact", "contact", false, "left"),
    commonColumn("Email", "email_id", false, "left"),
    commonColumn("CFMS ID", "cfms_id", false, "left"),
    commonColumn("Faculty Type", "fac_type_name", false, "left"),
    commonColumn("Appointment Category", "appoint_cat_name", false, "left"),
    commonColumn("Department", "dept_name", false, "left"),
    commonColumn("District", "dist_name", false, "left"),
    commonColumn("Caste", "caste", false, "left"),
    commonColumn("Sub Caste", "sub_caste_name", false, "left"),
    {
      id: "ews",
      header: "EWS",
      accessorKey: "ews",
      cell: ({ getValue }) => (
        <div style={{ width: "100%", display: "flex", justifyContent: "left", }} >
          {getValue() ? "Yes" : "No"}
        </div>
      ),
      Footer: true,
    },
    {
      id: "ex_serviceman",
      header: "Ex-Serviceman",
      accessorKey: "ex_serviceman",
      cell: ({ getValue }) => (
        <div style={{ width: "100%", display: "flex", justifyContent: "left", }} >
          {getValue() ? "Yes" : "No"}
        </div>
      ),
      Footer: true,
    },
    {
      id: "sports_quota",
      header: "Sports Quota",
      accessorKey: "sports_quota",

      cell: ({ getValue }) => (
        <div style={{ width: "100%", display: "flex", justifyContent: "left", }} >
          {getValue() ? "Yes" : "No"}
        </div>
      ),
      Footer: true,
    },
    {
      id: "is_ph",
      header: "PH",
      accessorKey: "is_ph",
      cell: ({ getValue }) => (
        <div style={{ width: "100%", display: "flex", justifyContent: "left", }} >
          {getValue() ? "Yes" : "No"}
        </div>
      ),
      Footer: true,
    },
    commonColumn("Disability %", "per_disability", true, "left"),
    commonColumn("Type of Disability", "type_of_disability", false, "left"),
    commonColumn("Qualification (At Appointment)", "qualification_appoint_name", false, "left",),
    commonColumn("Qualification (Later)", "qualification_later_name", false, "left"),
  ];




  const UniversityWiseColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "univ_name",
      header: "University Name",
      accessorKey: "univ_name",
      Footer: "Total",
    },
    {
      id: "tot_maker",
      header: " Maker",
      accessorKey: "tot_maker",
      cell: ({ row }) => (
        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          <span
            role="button"
            tabIndex={0}
            style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
            onClick={() => {
              GetFacultyData(row.original.ubcode, "maker");
              setUniversityName(row.original.univ_name);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                GetFacultyData(row.original.ubcode, "maker");
                setUniversityName(row.original.univ_name);
              }
            }}
          >
            {row.original.tot_maker}
          </span>
        </div>
      ),
      Footer: true,
    },
    {
      id: "tot_checker",
      header: "Approver",
      accessorKey: "tot_checker",
      cell: ({ row }) => (
        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          <span
            role="button"
            tabIndex={0}
            style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
            onClick={() => {
              GetFacultyData(row.original.ubcode, "checker");
              setUniversityName(row.original.univ_name);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                GetFacultyData(row.original.ubcode, "checker");
                setUniversityName(row.original.univ_name);
              }
            }}
          >
            {row.original.tot_checker}
          </span>
        </div>
      ),
      Footer: true,
    },
    {
      id: "total",
      header: "Total",
      accessorKey: "total",
      cell: ({ row }) => (
        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          <span
            role="button"
            tabIndex={0}
            style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
            onClick={() => {
              GetFacultyData(row.original.ubcode, "total");
              setUniversityName(row.original.univ_name);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                GetFacultyData(row.original.ubcode, "total");
                setUniversityName(row.original.univ_name);
              }
            }}
          >
            {row.original.total}
          </span>
        </div>
      ),
      Footer: true,
    },
  ];
  return (
    <>
      {universityTable && (
        <>
          {universitydata?.length > 0 ? (
            <>
              <div className="overal-stathead">
                <span>University Wise  Faculty Report</span>
              </div>
              <div className="table-responsive">
                <CommonReactTable
                  data={universitydata}
                  columns={UniversityWiseColumns}
                  filename="University Wise report"
                  headerName="University Wise report"
                  showFooter={true}
                  showPagination={false}
                  showExcel={true}
                  showPrint={true}
                  excelFileName="University Wise report"
                />
              </div>
            </>
          ) : (
            <center className="text-danger h5">**** No Data Found ****</center>
          )}
        </>
      )
      }
      {
        facultyTable && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <jnb.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                <div className="overal-stathead">
                  <span>{`${universityName}-Faculty Wise Report`}</span>
                  <pre />
                </div>
              </jnb.Col>
              {/* <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setUniversityTable(true);
                    setSubjectTable(false);
                    setFacultyTable(false);
                  }}
                >
                  Back
                </button>
              </jnb.Col> */}


              <button type='button'
                className="btn btn-primary"

                style={{ marginBottom: "0px" }}
                onClick={() => {
                  setUniversityTable(true);
                  setSubjectTable(false);
                  setFacultyTable(false);
                }}
              >
                Back
              </button>
            </div>
            {facultydata?.length > 0 ? (
              <>
                <div className="table-responsive ">
                  <CommonReactTable
                    data={facultydata}
                    columns={facultyWiseColumns}
                    filename={`${universityName}-Faculty Wise report`}
                    headerName={`${universityName}-Faculty Wise report`}
                    showFooter={false}
                    showPagination={true}
                    showExcel={true}
                    showPrint={true}
                    excelFileName="Faculty Wise report"

                  />
                </div>
              </>
            ) : (
              <center className="text-danger h5">**** No Data Found ****</center>
            )}
          </>
        )
      }

    </>
  );
}
